import { render } from "./App.vue?vue&type=template&id=396ff4da"
const script = {}

import "./App.vue?vue&type=style&index=0&id=396ff4da&lang=css"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__